<h2
  class="tw:text-[26px] tw:md:text-[40px] tw:font-family-display tw:font-regular tw:text-primary tw:text-center"
>
  {{ text }}
</h2>
